import React, { useState, useEffect } from "react";
import { Button, Form, Container, Row, Col, Alert } from "@themesberg/react-bootstrap";
import Base from "../base";
import { get, post } from "../../services/back.service";
import ListTables from "../../components/shared/tables";

const ShiftMovements = ({ shifts = [], setShifts = [] }) => {
  const [amount, setAmount] = useState("");
  const [type, setType] = useState("incoming"); // input or output
  const [description, setDescription] = useState("");
  const [listMovements, setListMovements] = useState("");
  const [errorMessageList, setErrorMessageList] = useState("");
  const [errorMessageCreate, setErrorMessageCreate] = useState("");

  const getListMovement = async () => {
    const listmovement = await get('/cash/movements/', {})

    if (listmovement.success) {
      setListMovements(listmovement.data)
    } else {
      setErrorMessageList(listmovement.message);
    }
  }

  useEffect(() => {
    getListMovement()
  }, [])

  // Add a movement to a shift
  const handleAddMovement = async () => {
    if (!amount) {
      setErrorMessageCreate("Por favor ingrese un monto.");
      return;
    }

    const movement = {
      type: type,
      value: amount,
      description: description,
    };

    const createmovement = await post('/cash/movements/create/', movement, {})

    if (createmovement.success) {
      getListMovement()
    } else {
      setErrorMessageCreate(createmovement.message);
    }
  };

  return (
    <Base>
      <Container>
        <Row className="mb-4">
          <Col>
            <h3>Add Movement (Input/Output)</h3>
            {errorMessageCreate && <Alert variant="danger">{errorMessageCreate}</Alert>}
            <Form>
              <Form.Group className="mt-3">
                <Form.Label>Tipo Movimiento</Form.Label>
                <Form.Select value={type} onChange={(e) => setType(e.target.value)}>
                  <option value="incoming">Ingreso (Add Money)</option>
                  <option value="outcoming">Salida (Remove Money)</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>Monto</Form.Label>
                <Form.Control
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter amount"
                />
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label>Descripcion</Form.Label>
                <Form.Control
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                />
              </Form.Group>

              <Button
                variant="primary"
                onClick={handleAddMovement}
                className="mt-3"
                disabled={!amount}
              >
                Agregar movimiento
              </Button>
            </Form>
          </Col>
        </Row>

        <Row>
          <Col>
            <ListTables
              data={listMovements}
              editar={() => { <h3> Hols </h3> }}
              messageWd={errorMessageList}
              hideFirst={true}
            />
          </Col>
        </Row>
      </Container>
    </Base>
  );
};

export default ShiftMovements;
